module.exports = __webpack_public_path__ + "img/store-roermond.edbf70a5.png";